export default __webpack_public_path__ + "static/media/baby-10.47cfc0b5.svg";